import ContentLayout from '@/layouts/content-layout'
import TrendSoundView from '@/sections/trend-sounds/view/trend-sound-view'

export default function TrendSoundsPage() {
  return (
    <ContentLayout title="เสียงเทรนด์">
      <TrendSoundView />
    </ContentLayout>
  )
}
